module.exports = __webpack_public_path__ + "img/r-102.3b178d41.jpg";